import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UploadFileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"upload_file"}/>
}
